module.exports = __webpack_public_path__ + "img/logo.2289b4fb.png";